var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcbtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 198 160.4",
    style: {
      enableBackground: "new 0 0 198 160.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#191F29;}\n\t.st1{fill:none;}\n\t.st2{fill:#B5CD30;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.9,40.3c1.3-1.7,2.1-3.9,2.1-6.3v-0.6c0-5.4-4.3-9.9-9.6-10.2v-3.9h-6.8v3.8h-2.8v-3.8H146v3.8h-1.6H141 v6.8h3.4v7.4v6.8v8.2H141v6.8h3.4h1.6v3.1h6.8v-3.1h2.8v3.1h6.8v-3.1h0.3c5.9,0,10.6-4.8,10.6-10.6v-0.6 C173.3,45,172,42.2,169.9,40.3z M151.2,30.1h1.4h9.1c1.9,0,3.4,1.5,3.4,3.4V34c0,1.9-1.5,3.4-3.4,3.4h-10.6V30.1z M166.5,48.7 c0,2.1-1.7,3.8-3.8,3.8h-10h-1.4v-8.2h10.6h0.9c2.1,0,3.8,1.7,3.8,3.8V48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.1,160.4c-5.3,0-10.3,0-15.6,0c0,0,0,0,0,0L91.1,160.4C91.1,160.4,91.1,160.4,91.1,160.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.5,110.1c0-7.4,0-14.8,0-22.1C6.5,95.4,6.5,110.1,6.5,110.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.6,88.1c-3.1,0.6-6.2,0.9-9.4,0.9c-24.5,0-44.7-18.3-47.8-41.9c-28.3,0-56.5,0-84.8,0c0,0,0,0,0,0h-1 c-0.1,0-0.3,0-0.4,0l-0.1,0h-7.5v3.3l0,0c0,9.5,0,18.7,0,28.1c-1.9,0-3.8,0-5.6,0c-5.8,0.1-9.9,3.9-9.9,9.7 c-0.1,7.2-0.1,14.5,0,21.7c0.1,5.7,4.1,9.5,9.8,9.6c1.9,0,3.8,0,5.9,0c0,0.9,0,1.7,0,2.4c0,12.8,0.1,25.6,0.1,38.4h148.8 c1.2,0,1.9,0,1.9,0s0.2-0.7,0.2-4.8C166.6,133,166.6,110.5,166.6,88.1z M109.4,110.9c0,1.2-1,2.2-2.2,2.2L9,113 c-1.5-0.1-2.5-1.2-2.5-2.9c0,0,0-14.8,0-22.1c0-2,1.2-2.9,3-3l97.7,0c1.2,0,2.2,1,2.2,2.2V110.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 109.4,
    cy: 137.7,
    r: 12.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.2,0c-22.6,0-40.8,18.3-40.8,40.8s18.3,40.8,40.8,40.8S198,63.4,198,40.8S179.7,0,157.2,0z M157.2,75.3 c-19.1,0-34.5-15.4-34.5-34.5s15.4-34.5,34.5-34.5s34.5,15.4,34.5,34.5S176.2,75.3,157.2,75.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 32.5,
    cy: 66.3,
    r: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 135.5,
    className: "st2",
    width: 64.3,
    height: 4.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcbtc);
export default __webpack_public_path__ + "static/media/ccbtc.b783fc8885154736be50ce2a1fa42a51.svg";
export { ForwardRef as ReactComponent };